var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.PaperRankView = function (superClass) {
  extend(PaperRankView, superClass);
  function PaperRankView() {
    return PaperRankView.__super__.constructor.apply(this, arguments);
  }
  PaperRankView.prototype.initialize = function (options) {
    this.workId = options.workId;
    this.container = options.container;
    this.postRender();
    return this.fetch(function (_this) {
      return function (data) {
        return _this.handleData(data);
      };
    }(this));
  };
  PaperRankView.prototype.render = function () {};
  PaperRankView.prototype.postRender = function () {
    return this.ui = {
      $rankValue: this.$el.find('.js-paper-rank'),
      $container: $(this.container)
    };
  };
  PaperRankView.prototype.fetch = function (callback) {
    return window.Academia.paperRanksFetcher.queue(this.workId, callback);
  };
  PaperRankView.prototype.handleData = function (data) {
    var paperRank;
    paperRank = JSON.parse(data);
    return this.handlePaperRank(paperRank);
  };
  PaperRankView.prototype.handlePaperRank = function (paperRank) {
    if (paperRank.bragworthy) {
      this.insertValue(paperRank.value);
      return this.show();
    }
  };
  PaperRankView.prototype.insertValue = function (value) {
    return this.ui.$rankValue.text(value.toFixed(1));
  };
  PaperRankView.prototype.show = function () {
    this.ui.$container.removeClass('hidden');
    return this.$el.removeClass('hidden');
  };
  return PaperRankView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;